import * as React from 'react';
import { StyleProp, StyleSheet, TextStyle } from 'react-native';
import { Link as LinkBase } from 'secullum-react-native-ui';
import { Amarelo100, Cinza100 } from '../modules/layout';

interface Props {
  text: string;
  style?: StyleProp<TextStyle>;
  onPress: () => void;
  nativeID?: string;
}

// Padrão de links conforme o sistema principal (tema Secullum RH)
const styles = StyleSheet.create({
  link: {
    color: Cinza100,
    textDecorationLine: 'underline',
    textDecorationColor: Amarelo100
  }
});

const Link = ({ style, ...props }: Props) => (
  <LinkBase {...props} style={[styles.link, style]} />
);

export default Link;
